// extracted by mini-css-extract-plugin
export default {"products":"Bw-z","card":"Cw-z","oosMessaging":"Dw-z"};